import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const CurrencyInput = ({ label, name, placeholder, register, setValue, trigger, errors, rules = {}, initialValue }) => {
  const [value, setValueState] = useState('R$ 0,00');

  const formatToBRL = (value) => {
    const numericValue = parseFloat(value.replace(/\D/g, '')) / 100;
    return numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    const formattedValue = formatToBRL(rawValue);
    setValueState(formattedValue);

    const numericString = (parseFloat(rawValue) / 100).toFixed(2);
    setValue(name, numericString, { shouldValidate: true });
    trigger(name);
  };

  useEffect(() => {
    if (initialValue !== undefined && initialValue !== null) {
      console.log(initialValue);
      const formattedInitialValue = formatToBRL(String(initialValue).replace('.', '').replace(',', ''));
      setValueState(formattedInitialValue);
      setValue(name, parseFloat(initialValue).toFixed(2));
    }
  }, [initialValue, name, setValue]);

  useEffect(() => {
    register(name, {
      ...rules,
      setValueAs: (val) => {
        const numericVal = String(val || '').replace(/[^\d]/g, '');
        return (parseFloat(numericVal) / 100).toFixed(2);
      },
    });
  }, [name, register, rules]);

  return (
    <Form.Group controlId={name} className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
        autoComplete='off'
      />
      {errors[name] && <Form.Control.Feedback type="invalid">{errors[name].message}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default CurrencyInput;